module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item-schedule",
    on: {
      "click": function($event) {
        return _vm.selectScheduleItem(_vm.value)
      }
    }
  }, [_c('v-subheader', {
    staticClass: "header-18"
  }, [_vm._v(_vm._s(_vm.value.name))]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [(!_vm.value.priceVariations) ? [_c('span', {
    staticClass: "item-price"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.value.price)))])] : [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('span', {
    staticClass: "item-price",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.value.priceTable[0].price)))]), (_vm.value.priceTable.length > 1) ? _c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v(" e mais " + _vm._s(_vm.value.priceTable.length - 1) + "...")]) : _vm._e(), _vm._v(" "), _c('span', [_c('ul', _vm._l((_vm.value.priceTable), function(price, i) {
    return _c('li', {
      key: i
    }, [_vm._v(_vm._s(price.description) + " - " + _vm._s(_vm._f("currency")(price.price)))])
  }), 0)])])]], 2), _vm._v(" "), _c('v-list-tile-sub-title', [(!_vm.value.priceVariations) ? [_vm._v("\n           " + _vm._s(_vm.value.description) + "\n         ")] : [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.value.description))]), _vm._v(" "), _c('span', [_c('ul', _vm._l((_vm.value.priceTable), function(price, i) {
    return _c('li', {
      key: i
    }, [_vm._v(_vm._s(price.description) + " - " + _vm._s(_vm._f("currency")(price.price)))])
  }), 0)])])]], 2)], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.value.priceVariations) ? [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [(!_vm.selected) ? _c('v-icon', {
    attrs: {
      "slot": "activator",
      "color": "grey lighten-1"
    },
    slot: "activator"
  }, [_vm._v("\n             crop_square\n            ")]) : _c('v-icon', {
    attrs: {
      "slot": "activator",
      "color": "green darken-2"
    },
    slot: "activator"
  }, [_vm._v("\n             done\n            ")]), _vm._v(" "), _c('span', [_c('ul', _vm._l((_vm.value.priceTable), function(price, i) {
    return _c('li', {
      key: i
    }, [_vm._v(_vm._s(price.description) + " - " + _vm._s(_vm._f("currency")(price.price)))])
  }), 0)])], 1)] : [(!_vm.selected) ? _c('v-icon', {
    attrs: {
      "slot": "activator",
      "color": "grey lighten-1"
    },
    slot: "activator"
  }, [_vm._v("\n           crop_square\n         ")]) : _c('v-icon', {
    attrs: {
      "slot": "activator",
      "color": "green darken-2"
    },
    slot: "activator"
  }, [_vm._v("\n           done\n         ")])]], 2)], 1), _vm._v(" "), _c('v-divider')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c0d6d45","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/sharedComponents/item/list-box/index.vue
// module id = 501
// module chunks = 0 1